

























import { VModel } from 'vue-property-decorator';
import Vue from 'vue';
import Component from 'vue-class-component';

@Component
export default class ObisCodeAutocomplete extends Vue {
  @VModel({ default: null }) model!: number;
  filterData(item: any, queryText: string): boolean {
    return (
      item.number?.toLowerCase().includes(queryText.toLowerCase()) ||
      item.description?.toLowerCase().includes(queryText.toLowerCase())
    );
  }
  items = [
    {
      id: 1,
      number: "1.8.0",
      description: "Positive active energy (A+) total [kWh]"
    },
    {
      id: 2,
      number: "1.8.1",
      description: "Positive active energy (A+) in tariff T1 [kWh]"
    },
    {
      id: 3,
      number: "1.8.2",
      description: "Positive active energy (A+) in tariff T2 [kWh]"
    },
    {
      id: 4,
      number: "1.8.3",
      description: "Positive active energy (A+) in tariff T3 [kWh]"
    },
    {
      id: 5,
      number: "1.8.4",
      description: "Positive active energy (A+) in tariff T4 [kWh]"
    },
    {
      id: 6,
      number: "2.8.0",
      description: "Negative active energy (A+) total [kWh]"
    },
    {
      id: 7,
      number: "2.8.1",
      description: "Negative active energy (A+) in tariff T1 [kWh]"
    },
    {
      id: 8,
      number: "2.8.2",
      description: "Negative active energy (A+) in tariff T2 [kWh]"
    },
    {
      id: 9,
      number: "2.8.3",
      description: "Negative active energy (A+) in tariff T3 [kWh]"
    },
    {
      id: 10,
      number: "2.8.4",
      description: "Negative active energy (A+) in tariff T4 [kWh]"
    },
    {
      id: 11,
      number: "15.8.0",
      description: "Absolute active energy (A+) total [kWh]"
    },
    {
      id: 12,
      number: "15.8.1",
      description: "Absolute active energy (A+) in tariff T1 [kWh]"
    },
    {
      id: 13,
      number: "15.8.2",
      description: "Absolute active energy (A+) in tariff T2 [kWh]"
    },
    {
      id: 14,
      number: "15.8.3",
      description: "Absolute active energy (A+) in tariff T3 [kWh]"
    },
    {
      id: 15,
      number: "15.8.4",
      description: "Absolute active energy (A+) in tariff T4 [kWh]"
    },
    {
      id: 16,
      number: "16.8.0",
      description: "Sum active energy without reverse blockade (A+ - A-) total [kWh]"
    },
    {
      id: 17,
      number: "16.8.",
      description: "Sum active energy without reverse blockade (A+ - A-) in tariff T1 [kWh]"
    },
    {
      id: 18,
      number: "16.8.2",
      description: "Sum active energy without reverse blockade (A+ - A-) in tariff T2 [kWh]"
    },
    {
      id: 19,
      number: "16.8.3",
      description: "Sum active energy without reverse blockade (A+ - A-) in tariff T3 [kWh]"
    },
    {
      id: 20,
      number: "16.8.4",
      description: "Sum active energy without reverse blockade (A+ - A-) in tariff T4 [kWh]"
    },
    {
      id: 21,
      number: "3.8.0",
      description: "Positive reactive energy (Q+) total [kvarh]"
    },
    {
      id: 22,
      number: "3.8.1",
      description: "Positive reactive energy (Q+) in tariff T1 [kvarh]"
    },
    {
      id: 23,
      number: "3.8.2",
      description: "Positive reactive energy (Q+) in tariff T2 [kvarh]"
    },
    {
      id: 24,
      number: "3.8.3",
      description: "Positive reactive energy (Q+) in tariff T3 [kvarh]"
    },
    {
      id: 25,
      number: "3.8.4",
      description: "Positive reactive energy (Q+) in tariff T4 [kvarh]"
    },
    {
      id: 26,
      number: "4.8.0",
      description: "Negative reactive energy (Q-) total [kvarh]"
    },
    {
      id: 27,
      number: "4.8.1",
      description: "Negative reactive energy (Q-) in tariff T1 [kvarh]"
    },
    {
      id: 28,
      number: "4.8.2",
      description: "Negative reactive energy (Q-) in tariff T2 [kvarh]"
    },
    {
      id: 29,
      number: "4.8.3",
      description: "Negative reactive energy (Q-) in tariff T3 [kvarh]"
    },
    {
      id: 30,
      number: "4.8.4",
      description: "Negative reactive energy (Q-) in tariff T4 [kvarh]"
    },
    {
      id: 31,
      number: "5.8.0",
      description: "Imported inductive reactive energy in 1-st quadrant (Q1) total [kvarh]"
    },
    {
      id: 32,
      number: "5.8.1",
      description: "Imported inductive reactive energy in 1-st quadrant (Q1) in tariff T1 [kvarh]"
    },
    {
      id: 33,
      number: "5.8.2",
      description: "Imported inductive reactive energy in 1-st quadrant (Q1) in tariff T2 [kvarh]"
    },
    {
      id: 34,
      number: "5.8.3",
      description: "Imported inductive reactive energy in 1-st quadrant (Q1) in tariff T3 [kvarh]"
    },
    {
      id: 35,
      number: "5.8.4",
      description: "Imported inductive reactive energy in 1-st quadrant (Q1) in tariff T4 [kvarh]"
    },
    {
      id: 36,
      number: "6.8.0",
      description: "Imported capacitive reactive energy in 2-nd quadrant (Q2) total [kvarh]"
    },
    {
      id: 37,
      number: "6.8.1",
      description: "Imported capacitive reactive energy in 2-nd quadr. (Q2) in tariff T1 [kvarh]"
    },
    {
      id: 38,
      number: "6.8.2",
      description: "Imported capacitive reactive energy in 2-nd quadr. (Q2) in tariff T2 [kvarh]"
    },
    {
      id: 39,
      number: "6.8.3",
      description: "Imported capacitive reactive energy in 2-nd quadr. (Q2) in tariff T3 [kvarh]"
    },
    {
      id: 40,
      number: "6.8.4",
      description: "Imported capacitive reactive energy in 2-nd quadr. (Q2) in tariff T4 [kvarh]"
    },
    {
      id: 41,
      number: "7.8.0",
      description: "Exported inductive reactive energy in 3-rd quadrant (Q3) total [kvarh]"
    },
    {
      id: 42,
      number: "7.8.1",
      description: "Exported inductive reactive energy in 3-rd quadrant (Q3) in tariff T1 [kvarh]"
    },
    {
      id: 43,
      number: "7.8.2",
      description: "Exported inductive reactive energy in 3-rd quadrant (Q3) in tariff T2 [kvarh]"
    },
    {
      id: 44,
      number: "7.8.3",
      description: "Exported inductive reactive energy in 3-rd quadrant (Q3) in tariff T3 [kvarh]"
    },
    {
      id: 45,
      number: "7.8.4",
      description: "Exported inductive reactive energy in 3-rd quadrant (Q3) in tariff T4 [kvarh]"
    },
    {
      id: 46,
      number: "8.8.0",
      description: "Exported capacitive reactive energy in 4-th quadrant (Q4) total [kvarh]"
    },
    {
      id: 47,
      number: "8.8.1",
      description: "Exported capacitive reactive energy in 4-th quadr. (Q4) in tariff T1 [kvarh]"
    },
    {
      id: 48,
      number: "8.8.2",
      description: "Exported capacitive reactive energy in 4-th quadr. (Q4) in tariff T2 [kvarh]"
    },
    {
      id: 49,
      number: "8.8.3",
      description: "Exported capacitive reactive energy in 4-th quadr. (Q4) in tariff T3 [kvarh]"
    },
    {
      id: 50,
      number: "8.8.4",
      description: "Exported capacitive reactive energy in 4-th quadr. (Q4) in tariff T4 [kvarh]"
    },
    {
      id: 51,
      number: "9.8.0",
      description: "Apparent energy (S+) total [kVAh]"
    },
    {
      id: 52,
      number: "9.8.1",
      description: "Apparent energy (S+) in tariff T1 [kVAh]"
    },
    {
      id: 53,
      number: "9.8.2",
      description: "Apparent energy (S+) in tariff T2 [kVAh]"
    },
    {
      id: 54,
      number: "9.8.3",
      description: "Apparent energy (S+) in tariff T3 [kVAh]"
    },
    {
      id: 55,
      number: "9.8.4",
      description: "Apparent energy (S+) in tariff T4 [kVAh]"
    },
    {
      id: 56,
      number: "21.8.0",
      description: "Positive active energy (A+) in phase L1 total [kWh]"
    },
    {
      id: 57,
      number: "41.8.0",
      description: "Positive active energy (A+) in phase L2 total [kWh]"
    },
    {
      id: 58,
      number: "61.8.0",
      description: "Positive active energy (A+) in phase L3 total [kWh]"
    },
    {
      id: 59,
      number: "22.8.0",
      description: "Negative active energy (A-) in phase L1 total [kWh]"
    },
    {
      id: 60,
      number: "42.8.0",
      description: "Negative active energy (A-) in phase L2 total [kWh]"
    },
    {
      id: 61,
      number: "62.8.0",
      description: "Negative active energy (A-) in phase L3 total [kWh]"
    },
    {
      id: 62,
      number: "35.8.0",
      description: "Absolute active energy (|A|) in phase L1 total [kWh]"
    },
    {
      id: 63,
      number: "55.8.0",
      description: "Absolute active energy (|A|) in phase L2 total [kWh]"
    },
    {
      id: 64,
      number: "75.8.0",
      description: "Absolute active energy (|A|) in phase L3 total [kWh]"
    },
    {
      id: 65,
      number: "1.6.0",
      description: "Positive active maximum demand (A+) total [kW]"
    },
    {
      id: 66,
      number: "1.6.1",
      description: "Positive active maximum demand (A+) in tariff T1 [kW]"
    },
    {
      id: 67,
      number: "1.6.2",
      description: "Positive active maximum demand (A+) in tariff T2 [kW]"
    },
    {
      id: 68,
      number: "1.6.3",
      description: "Positive active maximum demand (A+) in tariff T3 [kW]"
    },
    {
      id: 69,
      number: "1.6.4",
      description: "Positive active maximum demand (A+) in tariff T4 [kW]"
    },
    {
      id: 70,
      number: "2.6.0",
      description: "Negative active maximum demand (A-) total [kW]"
    },
    {
      id: 71,
      number: "2.6.1",
      description: "Negative active maximum demand (A-) in tariff T1 [kW]"
    },
    {
      id: 72,
      number: "2.6.2",
      description: "Negative active maximum demand (A-) in tariff T2 [kW]"
    },
    {
      id: 73,
      number: "2.6.3",
      description: "Negative active maximum demand (A-) in tariff T3 [kW]"
    },
    {
      id: 74,
      number: "2.6.4",
      description: "Negative active maximum demand (A-) in tariff T4 [kW]"
    },
    {
      id: 75,
      number: "15.6.0",
      description: "Absolute active maximum demand (|A|) total [kW]"
    },
    {
      id: 76,
      number: "15.6.1",
      description: "Absolute active maximum demand (|A|) in tariff T1 [kW]"
    },
    {
      id: 77,
      number: "15.6.2",
      description: "Absolute active maximum demand (|A|) in tariff T2 [kW]"
    },
    {
      id: 78,
      number: "15.6.3",
      description: "Absolute active maximum demand (|A|) in tariff T3 [kW]"
    },
    {
      id: 79,
      number: "15.6.4",
      description: "Absolute active maximum demand (|A|) in tariff T4 [kW]"
    },
    {
      id: 80,
      number: "3.6.0",
      description: "Positive reactive maximum demand (Q+) total [kvar]"
    },
    {
      id: 81,
      number: "4.6.0",
      description: "Negative reactive maximum demand (Q-) total [kvar]"
    },
    {
      id: 82,
      number: "5.6.0",
      description: "Reactive maximum demand in Q1 (Q1) total [kvar]"
    },
    {
      id: 83,
      number: "6.6.0",
      description: "Reactive maximum demand in Q2 (Q2) total [kvar]"
    },
    {
      id: 84,
      number: "7.6.0",
      description: "Reactive maximum demand in Q3 (Q3) total [kvar]"
    },
    {
      id: 85,
      number: "8.6.0",
      description: "Reactive maximum demand in Q4 (Q4) total [kvar]"
    },
    {
      id: 86,
      number: "9.6.0",
      description: "Apparent maximum demand (S+) total [kVA]"
    },
    {
      id: 87,
      number: "1.2.0",
      description: "Positive active cumulative maximum demand (A+) total [kW]"
    },
    {
      id: 88,
      number: "1.2.1",
      description: "Positive active cumulative maximum demand (A+) in tariff T1 [kW]"
    },
    {
      id: 89,
      number: "1.2.2",
      description: "Positive active cumulative maximum demand (A+) in tariff T2 [kW]"
    },
    {
      id: 90,
      number: "1.2.3",
      description: "Positive active cumulative maximum demand (A+) in tariff T3 [kW]"
    },
    {
      id: 91,
      number: "1.2.4",
      description: "Positive active cumulative maximum demand (A+) in tariff T4 [kW]"
    },
    {
      id: 92,
      number: "2.2.0",
      description: "Negative active cumulative maximum demand (A-) total [kW]"
    },
    {
      id: 93,
      number: "2.2.1",
      description: "Negative active cumulative maximum demand (A-) in tariff T1 [kW]"
    },
    {
      id: 94,
      number: "2.2.2",
      description: "Negative active cumulative maximum demand (A-) in tariff T2 [kW]"
    },
    {
      id: 95,
      number: "2.2.3",
      description: "Negative active cumulative maximum demand (A-) in tariff T3 [kW]"
    },
    {
      id: 96,
      number: "2.2.4",
      description: "Negative active cumulative maximum demand (A-) in tariff T4 [kW]"
    },
    {
      id: 97,
      number: "15.2.0",
      description: "Absolute active cumulative maximum demand (|A|) total [kW]"
    },
    {
      id: 98,
      number: "15.2.1",
      description: "Absolute active cumulative maximum demand (|A|) in tariff T1 [kW]"
    },
    {
      id: 99,
      number: "15.2.2",
      description: "Absolute active cumulative maximum demand (|A|) in tariff T2 [kW]"
    },
    {
      id: 100,
      number: "15.2.3",
      description: "Absolute active cumulative maximum demand (|A|) in tariff T3 [kW]"
    },
    {
      id: 101,
      number: "15.2.4",
      description: "Absolute active cumulative maximum demand (|A|) in tariff T4 [kW]"
    },
    {
      id: 102,
      number: "3.2.0",
      description: "Positive reactive cumulative maximum demand (Q+) total [kvar]"
    },
    {
      id: 103,
      number: "4.2.0",
      description: "Negative reactive cumulative maximum demand (Q-) total [kvar]"
    },
    {
      id: 104,
      number: "5.2.0",
      description: "Reactive cumulative maximum demand in Q1 (Q1) total [kvar]"
    },
    {
      id: 105,
      number: "6.2.0",
      description: "Reactive cumulative maximum demand in Q2 (Q2) total [kvar]"
    },
    {
      id: 106,
      number: "7.2.0",
      description: "Reactive cumulative maximum demand in Q3 (Q3) total [kvar]"
    },
    {
      id: 107,
      number: "8.2.0",
      description: "Reactive cumulative maximum demand in Q4 (Q4) total [kvar]"
    },
    {
      id: 108,
      number: "9.2.0",
      description: "Apparent cumulative maximum demand (S+) total [kVA]"
    },
    {
      id: 109,
      number: "1.4.0",
      description: "Positive active demand in a current demand period (A+) [kW]"
    },
    {
      id: 110,
      number: "2.4.0",
      description: "Negative active demand in a current demand period (A-) [kW]"
    },
    {
      id: 111,
      number: "15.4.0",
      description: "Absolute active demand in a current demand period (|A|) [kW]"
    },
    {
      id: 112,
      number: "3.4.0",
      description: "Positive reactive demand in a current demand period (Q+) [kvar]"
    },
    {
      id: 113,
      number: "4.4.0",
      description: "Negative reactive demand in a current demand period (Q-) [kvar]"
    },
    {
      id: 114,
      number: "5.4.0",
      description: "Reactive demand in a current demand period in Q1 (Q1) [kvar]"
    },
    {
      id: 115,
      number: "6.4.0",
      description: "Reactive demand in a current demand period in Q2 (Q2) [kvar]"
    },
    {
      id: 116,
      number: "7.4.0",
      description: "Reactive demand in a current demand period in Q3 (Q3) [kvar]"
    },
    {
      id: 117,
      number: "8.4.0",
      description: "Reactive demand in a current demand period in Q4 (Q4) [kvar]"
    },
    {
      id: 118,
      number: "9.4.0",
      description: "Apparent demand in a current demand period (S+) [kVA]"
    },
    {
      id: 119,
      number: "1.5.0",
      description: "Positive active demand in the last completed demand period (A+) [kW]"
    },
    {
      id: 120,
      number: "2.5.0",
      description: "Negative active demand in the last completed demand period (A-) [kW]"
    },
    {
      id: 121,
      number: "15.5.0",
      description: "Absolute active demand in the last completed demand period (|A|) [kW]"
    },
    {
      id: 122,
      number: "3.5.0",
      description: "Positive reactive demand in the last completed demand period (Q+) [kvar]"
    },
    {
      id: 123,
      number: "4.5.0",
      description: "Negative reactive demand in the last completed demand period (Q-) [kvar]"
    },
    {
      id: 124,
      number: "5.5.0",
      description: "Reactive demand in the last completed demand period in Q1 (Q1) [kvar]"
    },
    {
      id: 125,
      number: "6.5.0",
      description: "Reactive demand in the last completed demand period in Q2 (Q2) [kvar]"
    },
    {
      id: 126,
      number: "7.5.0",
      description: "Reactive demand in the last completed demand period in Q3 (Q3) [kvar]"
    },
    {
      id: 127,
      number: "8.5.0",
      description: "Reactive demand in the last completed demand period in Q4 (Q4) [kvar]"
    },
    {
      id: 128,
      number: "9.5.0",
      description: "Apparent demand in the last completed demand period (S+) [kVA]"
    },
    {
      id: 129,
      number: "1.7.0",
      description: "Positive active instantaneous power (A+) [kW]"
    },
    {
      id: 130,
      number: "21.7.0",
      description: "Positive active instantaneous power (A+) in phase L1 [kW]"
    },
    {
      id: 131,
      number: "41.7.0",
      description: "Positive active instantaneous power (A+) in phase L2 [kW]"
    },
    {
      id: 132,
      number: "61.7.0",
      description: "Positive active instantaneous power (A+) in phase L3 [kW]"
    },
    {
      id: 133,
      number: "2.7.0",
      description: "Negative active instantaneous power (A-) [kW]"
    },
    {
      id: 134,
      number: "22.7.0",
      description: "Negative active instantaneous power (A-) in phase L1 [kW]"
    },
    {
      id: 135,
      number: "42.7.0",
      description: "Negative active instantaneous power (A-) in phase L2 [kW]"
    },
    {
      id: 136,
      number: "62.7.0",
      description: "Negative active instantaneous power (A-) in phase L3 [kW]"
    },
    {
      id: 137,
      number: "15.7.0",
      description: "Absolute active instantaneous power (|A|) [kW]"
    },
    {
      id: 138,
      number: "35.7.0",
      description: "Absolute active instantaneous power (|A|) in phase L1 [kW]"
    },
    {
      id: 139,
      number: "55.7.0",
      description: "Absolute active instantaneous power (|A|) in phase L2 [kW]"
    },
    {
      id: 140,
      number: "75.7.0",
      description: "Absolute active instantaneous power (|A|) in phase L3 [kW]"
    },
    {
      id: 141,
      number: "16.7.0",
      description: "Sum active instantaneous power (A+ - A-) [kW]"
    },
    {
      id: 142,
      number: "36.7.0",
      description: "Sum active instantaneous power (A+ - A-) in phase L1 [kW]"
    },
    {
      id: 143,
      number: "56.7.0",
      description: "Sum active instantaneous power (A+ - A-) in phase L2 [kW]"
    },
    {
      id: 144,
      number: "76.7.0",
      description: "Sum active instantaneous power (A+ - A-) in phase L3 [kW]"
    },
    {
      id: 145,
      number: "3.7.0",
      description: "Positive reactive instantaneous power (Q+) [kvar]"
    },
    {
      id: 146,
      number: "23.7.0",
      description: "Positive reactive instantaneous power (Q+) in phase L1 [kvar]"
    },
    {
      id: 147,
      number: "43.7.0",
      description: "Positive reactive instantaneous power (Q+) in phase L2 [kvar]"
    },
    {
      id: 148,
      number: "63.7.0",
      description: "Positive reactive instantaneous power (Q+) in phase L3 [kvar]"
    },
    {
      id: 149,
      number: "4.7.0",
      description: "Negative reactive instantaneous power (Q-) [kvar]"
    },
    {
      id: 150,
      number: "24.7.0",
      description: "Negative reactive instantaneous power (Q-) in phase L1 [kvar]"
    },
    {
      id: 151,
      number: "44.7.0",
      description: "Negative reactive instantaneous power (Q-) in phase L2 [kvar]"
    },
    {
      id: 152,
      number: "64.7.0",
      description: "Negative reactive instantaneous power (Q-) in phase L3 [kvar]"
    },
    {
      id: 153,
      number: "9.7.0",
      description: "Apparent instantaneous power (S+) [kVA]"
    },
    {
      id: 154,
      number: "29.7.0",
      description: "Apparent instantaneous power (S+) in phase L1 [kVA]"
    },
    {
      id: 155,
      number: "49.7.0",
      description: "Apparent instantaneous power (S+) in phase L2 [kVA]"
    },
    {
      id: 156,
      number: "69.7.0",
      description: "Apparent instantaneous power (S+) in phase L3 [kVA]"
    },
    {
      id: 157,
      number: "11.7.0",
      description: "Instantaneous current (I) [A]"
    },
    {
      id: 158,
      number: "31.7.0",
      description: "Instantaneous current (I) in phase L1 [A]"
    },
    {
      id: 159,
      number: "51.7.0",
      description: "Instantaneous current (I) in phase L2 [A]"
    },
    {
      id: 160,
      number: "71.7.0",
      description: "Instantaneous current (I) in phase L3 [A]"
    },
    {
      id: 161,
      number: "91.7.0",
      description: "Instantaneous current (I) in neutral [A]"
    },
    {
      id: 162,
      number: "11.6.0",
      description: "Maximum current (I max) [A]"
    },
    {
      id: 163,
      number: "31.6.0",
      description: "Maximum current (I max) in phase L1 [A]"
    },
    {
      id: 164,
      number: "51.6.0",
      description: "Maximum current (I max) in phase L2 [A]"
    },
    {
      id: 165,
      number: "71.6.0",
      description: "Maximum current (I max) in phase L3 [A]"
    },
    {
      id: 166,
      number: "91.6.0",
      description: "Maximum current (I max) in neutral [A]"
    },
    {
      id: 167,
      number: "12.7.0",
      description: "Instantaneous voltage (U) [V]"
    },
    {
      id: 168,
      number: "32.7.0",
      description: "Instantaneous voltage (U) in phase L1 [V]"
    },
    {
      id: 169,
      number: "52.7.0",
      description: "Instantaneous voltage (U) in phase L2 [V]"
    },
    {
      id: 170,
      number: "72.7.0",
      description: "Instantaneous voltage (U) in phase L3 [V]"
    },
    {
      id: 171,
      number: "13.7.0",
      description: "Instantaneous power factor"
    },
    {
      id: 172,
      number: "33.7.0",
      description: "Instantaneous power factor in phase L1"
    },
    {
      id: 173,
      number: "53.7.0",
      description: "Instantaneous power factor in phase L2"
    },
    {
      id: 174,
      number: "73.7.0",
      description: "Instantaneous power factor in phase L3"
    },
    {
      id: 175,
      number: "14.7.0",
      description: "Frequency [Hz]"
    },
    {
      id: 176,
      number: "C.53.1",
      description: "Tamper 1 energy register"
    },
    {
      id: 177,
      number: "C.53.2",
      description: "Tamper 2 energy register"
    },
    {
      id: 178,
      number: "C.53.3",
      description: "Tamper 3 energy register"
    },
    {
      id: 179,
      number: "C.53.4",
      description: "Tamper 4 energy register"
    },
    {
      id: 180,
      number: "C.53.11",
      description: "Tamper 5 energy register"
    },
    {
      id: 181,
      number: "C.53.5",
      description: "Tamper 1 time counter register"
    },
    {
      id: 182,
      number: "C.53.6",
      description: "Tamper 2 time counter register"
    },
    {
      id: 183,
      number: "C.53.7",
      description: "Tamper 3 time counter register"
    },
    {
      id: 184,
      number: "C.53.9",
      description: "Tamper 4 time counter register"
    },
    {
      id: 185,
      number: "C.53.10",
      description: "Tamper 5 time counter register"
    },
    {
      id: 186,
      number: "C.2.0",
      description: "Event parameters change - counter"
    },
    {
      id: 187,
      number: "C.2.1",
      description: "Event parameters change - timestamp"
    },
    {
      id: 188,
      number: "C.51.1",
      description: "Event terminal cover opened - counter"
    },
    {
      id: 189,
      number: "C.51.2",
      description: "Event terminal cover opened - timestamp"
    },
    {
      id: 190,
      number: "C.51.3",
      description: "Event main cover opened - counter"
    },
    {
      id: 191,
      number: "C.51.4",
      description: "Event main cover opened - timestamp"
    },
    {
      id: 192,
      number: "C.51.5",
      description: "Event magnetic field detection start - counter"
    },
    {
      id: 193,
      number: "C.51.6",
      description: "Event magnetic field detection start - timestamp"
    },
    {
      id: 194,
      number: "C.51.7",
      description: "Event reverse power flow - counter"
    },
    {
      id: 195,
      number: "C.51.8",
      description: "Event reverse power flow - timestamp"
    },
    {
      id: 196,
      number: "C.7.0",
      description: "Event power down - counter"
    },
    {
      id: 197,
      number: "C.7.10",
      description: "Event power down - timestamp"
    },
    {
      id: 198,
      number: "C.51.13",
      description: "Event power up - counter"
    },
    {
      id: 199,
      number: "C.51.14",
      description: "Event power up – timestamp"
    },
    {
      id: 200,
      number: "C.51.15",
      description: "Event RTC (Real Time Clock) set - counter"
    },
    {
      id: 201,
      number: "C.51.16",
      description: "Event RTC (Real Time Clock) set - timestamp"
    },
    {
      id: 202,
      number: "C.51.21",
      description: "Event terminal cover closed - counter"
    },
    {
      id: 203,
      number: "C.51.22",
      description: "Event terminal cover closed - timestamp"
    },
    {
      id: 204,
      number: "C.51.23",
      description: "Event main cover closed - counter"
    },
    {
      id: 205,
      number: "C.51.24",
      description: "Event main cover closed - timestamp"
    },
    {
      id: 206,
      number: "C.51.25",
      description: "Event log-book 1 erased - counter"
    },
    {
      id: 207,
      number: "C.51.26",
      description: "Event log-book 1 erased - timestamp"
    },
    {
      id: 208,
      number: "C.51.27",
      description: "Event fraud start - counter"
    },
    {
      id: 209,
      number: "C.51.28",
      description: "Event fraud start - timestamp"
    },
    {
      id: 210,
      number: "C.51.29",
      description: "Event fraud stop - counter"
    },
    {
      id: 211,
      number: "C.51.30",
      description: "Event fraud stop - timestamp"
    },
    {
      id: 212,
      number: "0.9.1",
      description: "Current time (hh:mm:ss)"
    },
    {
      id: 213,
      number: "0.9.2",
      description: "Date (YY.MM.DD or DD.MM.YY)"
    },
    {
      id: 214,
      number: "0.9.4",
      description: "Date and Time (YYMMDDhhmmss)"
    },
    {
      id: 215,
      number: "0.8.0",
      description: "Demand period [min]"
    },
    {
      id: 216,
      number: "0.8.4",
      description: "Load profile period [min] (option)"
    },
    {
      id: 217,
      number: "0.0.0",
      description: "Device address 1"
    },
    {
      id: 218,
      number: "0.0.1",
      description: "Device address 2"
    },
    {
      id: 219,
      number: "0.1.0",
      description: "MD reset counter"
    },
    {
      id: 220,
      number: "0.1.2",
      description: "MD reset timestamp"
    },
    {
      id: 221,
      number: "0.2.0",
      description: "Firmware version"
    },
    {
      id: 222,
      number: "0.2.2",
      description: "Tariff program ID"
    },
    {
      id: 223,
      number: "C.1.0",
      description: "Meter serial number"
    },
    {
      id: 224,
      number: "C.1.2",
      description: "Parameters file code"
    },
    {
      id: 225,
      number: "C.1.4",
      description: "Parameters check sum"
    },
    {
      id: 226,
      number: "C.1.5",
      description: "Firmware built date"
    },
    {
      id: 227,
      number: "C.1.6",
      description: "Firmware check sum"
    },
    {
      id: 228,
      number: "C.6.0",
      description: "Power down time counter"
    },
    {
      id: 229,
      number: "C.6.1",
      description: "Battery remaining capacity"
    },
    {
      id: 231,
      number: "C.87.0",
      description: "Active tariff"
    },
    {
      id: 232,
      number: "0.2.1",
      description: "Parameters scheme ID"
    },
    {
      id: 233,
      number: "C.60.9",
      description: "Fraud flag"
    },
    {
      id: 234,
      number: "0.3.0",
      description: "Active energy meter constant"
    },
    {
      id: 235,
      number: "0.4.2",
      description: "Current transformer ratio"
    },
    {
      id: 236,
      number: "0.4.3",
      description: "Voltage transformer ratio"
    },
    {
      id: 237,
      number: "17.7.0",
      description: "Average active power 15 min"
    },
    {
      id: 238,
      number: "T.1.1",
      description: "U L1L2"
    },
    {
      id: 239,
      number: "T.1.2",
      description: "U L2L3"
    },
    {
      id: 240,
      number: "T.1.3",
      description: "U L3L1"
    },
    {
      id: 241,
      number: "T.2.1",
      description: "THD I1"
    },
    {
      id: 242,
      number: "T.2.2",
      description: "THD I2"
    },
    {
      id: 243,
      number: "T.2.3",
      description: "THD I3"
    },
    {
      id: 244,
      number: "T.3.1",
      description: "THD UL1 or THDUL1L2"
    },
    {
      id: 245,
      number: "T.3.2",
      description: "THD UL2 or THDUL2L3"
    },
    {
      id: 246,
      number: "T.3.3",
      description: "THD UL3 or THDU31L1"
    },
    {
      id: 247,
      number: "T.4.0",
      description: "λtot"
    },
    {
      id: 248,
      number: "T.4.1",
      description: "λL1"
    },
    {
      id: 249,
      number: "T.4.2",
      description: "λL2"
    },
    {
      id: 250,
      number: "T.4.3",
      description: "λL3"
    },
    {
      id: 251,
      number: "T.5.1",
      description: "Voltage unbalance"
    },
    {
      id: 252,
      number: "T.5.2",
      description: "Current unbalance"
    },
    {
      id: 253,
      number: "T.6.1",
      description: "Reactive energy Q1"
    },
    {
      id: 254,
      number: "T.6.2",
      description: "Reactive energy Q2"
    },
    {
      id: 255,
      number: "T.6.3",
      description: "Reactive energy Q3"
    },
    {
      id: 256,
      number: "T.6.4",
      description: "Reactive energy Q4"
    },
    {
      id: 257,
      number: "T.7.1",
      description: "Reactive energy import"
    },
    {
      id: 258,
      number: "T.7.2",
      description: "Reactive energy export"
    },
    {
      id: 259,
      number: "131.7.0",
      description: null
    },
    {
      id: 260,
      number: "151.7.0",
      description: null
    },
    {
      id: 261,
      number: "171.7.0",
      description: null
    },
    {
      id: 262,
      number: "191.7.0",
      description: null
    },
    {
      id: 266,
      number: "temp",
      description: "Temperatura kompensatora"
    },
    {
      id: 277,
      number: "F.F.1",
      description: "bit16_alarm_2"
    },
    {
      id: 278,
      number: "F.F.2",
      description: "bit16_alarm_3"
    },
    {
      id: 279,
      number: "S.0.16",
      description: "bit16_status_0"
    },
    {
      id: 280,
      number: "S.1.16",
      description: "bit16_status_1"
    },
    {
      id: 281,
      number: "1.8.0.W.L",
      description: "Energia czynna pobrana A+"
    },
    {
      id: 282,
      number: "1.8.0.W.H",
      description: "Energia czynna pobrana A+"
    },
    {
      id: 283,
      number: "2.8.0.W.L",
      description: "Energia czynna oddana A-"
    },
    {
      id: 284,
      number: "2.8.0.W.H",
      description: "Energia czynna oddana A-"
    },
    {
      id: 285,
      number: "5.8.0.W.L",
      description: "Energia bierna I kwadrant R1"
    },
    {
      id: 286,
      number: "5.8.0.W.H",
      description: "Energia bierna I kwadrant R1"
    },
    {
      id: 287,
      number: "6.8.0.W.L",
      description: "Energia bierna II kwadrant R2"
    },
    {
      id: 288,
      number: "6.8.0.W.H",
      description: "Energia bierna II kwadrant R2"
    },
    {
      id: 289,
      number: "7.8.0.W.L",
      description: "Energia bierna III kwadrant R3"
    },
    {
      id: 290,
      number: "7.8.0.W.H",
      description: "Energia bierna III kwadrant R3"
    },
    {
      id: 291,
      number: "8.8.0.W.L",
      description: "Energia bierna IV kwadrant R4"
    },
    {
      id: 292,
      number: "8.8.0.W.H",
      description: "Energia bierna IV kwadrant R4"
    },
    {
      id: 293,
      number: "1.8.0.A.L",
      description: "Energia czynna pobrana A+"
    },
    {
      id: 294,
      number: "1.8.0.A.H",
      description: "Energia czynna pobrana A+"
    },
    {
      id: 295,
      number: "2.8.0.A.L",
      description: "Energia czynna oddana A-"
    },
    {
      id: 296,
      number: "2.8.0.A.H",
      description: "Energia czynna oddana A-"
    },
    {
      id: 297,
      number: "5.8.0.A.L",
      description: "Energia bierna I kwadrant R1"
    },
    {
      id: 298,
      number: "5.8.0.A.H",
      description: "Energia bierna I kwadrant R1"
    },
    {
      id: 299,
      number: "6.8.0.A.L",
      description: "Energia bierna II kwadrant R2"
    },
    {
      id: 300,
      number: "6.8.0.A.H",
      description: "Energia bierna II kwadrant R2"
    },
    {
      id: 301,
      number: "7.8.0.A.L",
      description: "Energia bierna III kwadrant R3"
    },
    {
      id: 302,
      number: "7.8.0.A.H",
      description: "Energia bierna III kwadrant R3"
    },
    {
      id: 303,
      number: "8.8.0.A.L",
      description: "Energia bierna IV kwadrant R4"
    },
    {
      id: 304,
      number: "8.8.0.A.H",
      description: "Energia bierna IV kwadrant R4"
    },
    {
      id: 230,
      number: "F.F.0",
      description: "bit16_alarm_1"
    },
    {
      id: 305,
      number: "---",
      description: "---"
    }
  ];
}
